export const information = {
  site: "jun88k36",
  endpoint: "https://api-jun88k36.freecodevip.org",
  // endpoint: "http://localhost:5039",


  cskh_url: "https://553389.com/jun88cskhp2",
  nav_url: "https://77jjun88.com/trangchu",
  key_free: "att.code.hau-dai.jun88-k36@2030$",
};
